import "./scss/core.scss";
import "./scss/index.scss";
import 'virtual:svg-icons-register';

import { createApp } from "vue";
import pinia from "./store";
import configureAxios from "./config/axios";
import App from './broadcast-portal-post-login.vue';
import router from './router/routes';
import { registerLayouts } from "./components";

const app = createApp(App);

app.use(pinia);
app.use(router);

registerLayouts(app);

app.mount('#app');

configureAxios();